<div class="search-result-row" [class.active]="active()">
  <button type="button" class="row-button click-animation" (click)="onSelect()">
    @if (item().type === 'news' && item().thumbUrl) {
      <app-image
        [alt]="item().title"
        className="row-thumb"
        loading="lazy"
        [height]="46"
        [width]="46"
        [src]="item().thumbUrl ?? '' | getImagePath: 46 : 46" />
    } @else {
      <span class="icon-tile" aria-hidden="true">
        <app-icon [alt]="typeBadge()" [src]="typeIcon()" [height]="22" [width]="22" className="type-icon" />
      </span>
    }
    <span class="text-block">
      <span class="title">{{ item().title }}</span>
      <span class="meta">{{ item().meta }}</span>
    </span>
    <span class="type-badge">{{ typeBadge() }}</span>
    @if (active()) {
      <app-icon alt="" [ariaHidden]="true" src="chevron-right.svg" [height]="18" [width]="18" className="chevron" />
    }
  </button>
</div>
